export { default as Section } from "./Section";
export { default as SectionHeader } from "./SectionHeader";
export type {
  SectionHeaderProps,
  SectionPadding,
  SectionProps,
} from "./Section.types";
